<template>
  <div>
    <span :id="`${id}`">
      {{ $t('report.text.noData') }}
    </span>
    <b-tooltip :target="`${id}`" placement="topright">
      <span>{{ $t('report.text.noDataDesc') }}</span>
    </b-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
}
</script>
